/* Tienda Flashs - landing de producto (secciones tf-lp-*).
   Aparicion al hacer scroll, contadores, curva ANC, pestanas y carrusel. Respeta prefers-reduced-motion. */
(function () {
  if (window.__tfLp) return;
  window.__tfLp = true;
  var root = document.documentElement;
  // Animaciones siempre activas (decisión de la tienda), también con "reducir movimiento".
  var reduce = false;
  var canObserve = 'IntersectionObserver' in window;
  if (!reduce && canObserve) root.classList.add('tf-lp-js');

  function formatNum(n, dec) {
    return n.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }

  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-to'));
    if (isNaN(to)) return;
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var prefix = el.getAttribute('data-prefix') || '';
    if (reduce || !canObserve) { el.textContent = prefix + formatNum(to, dec); return; }
    var start = null, dur = 1400;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + formatNum(to * eased, dec);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function prepChart(chart) {
    var path = chart.querySelector('.curve');
    if (path && path.getTotalLength) {
      var len = Math.ceil(path.getTotalLength());
      path.style.setProperty('--len', len);
    }
  }

  function onIn(el) {
    el.classList.add('tf-lp-in');
    el.querySelectorAll('[data-to]').forEach(countUp);
    if (el.matches('[data-to]')) countUp(el);
  }

  function initReveal(scope) {
    var els = scope.querySelectorAll('.tf-lp-reveal, .tf-lp-stagger, .tf-lp-zoom, .tf-lp-chart, .tf-lp-cmp, .tf-lp-count');
    scope.querySelectorAll('.tf-lp-chart').forEach(prepChart);
    if (reduce || !canObserve) { els.forEach(onIn); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { onIn(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Red de seguridad: si algo bloquea el observer, se muestra todo.
    setTimeout(function () {
      els.forEach(function (el) {
        if (!el.classList.contains('tf-lp-in') && el.getBoundingClientRect().top < window.innerHeight) onIn(el);
      });
    }, 4000);
  }

  function initTabs(scope) {
    scope.querySelectorAll('.tf-lp-tabs').forEach(function (tabs) {
      var btns = tabs.querySelectorAll('[role="tab"]');
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { select(i); });
        b.addEventListener('keydown', function (ev) {
          if (ev.key === 'ArrowRight') { select((i + 1) % btns.length); btns[(i + 1) % btns.length].focus(); }
          if (ev.key === 'ArrowLeft') { var j = (i - 1 + btns.length) % btns.length; select(j); btns[j].focus(); }
        });
      });
      function select(i) {
        btns.forEach(function (b, k) {
          var on = k === i;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    });
  }

  function initCarousels(scope) {
    scope.querySelectorAll('.tf-lp-car').forEach(function (car) {
      var track = car.querySelector('.tf-lp-car__track');
      var slides = track ? track.children : [];
      var dots = car.querySelectorAll('.tf-lp-car__dot');
      if (!track || !slides.length) return;
      function go(i) {
        var s = slides[Math.max(0, Math.min(i, slides.length - 1))];
        track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }
      function current() {
        var x = track.scrollLeft, best = 0, d = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var dd = Math.abs(slides[i].offsetLeft - track.offsetLeft - x);
          if (dd < d) { d = dd; best = i; }
        }
        return best;
      }
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { go(i); }); });
      var prev = car.querySelector('[data-dir="prev"]'), next = car.querySelector('[data-dir="next"]');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var c = current();
          dots.forEach(function (dot, i) { dot.setAttribute('aria-current', i === c ? 'true' : 'false'); });
        }, 60);
      }, { passive: true });
    });
  }

  // Botones "Elegir color": suben al formulario del producto (selector de variantes).
  function initScrollTo(scope) {
    scope.querySelectorAll('[data-tf-lp-buy]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var target = document.querySelector('variant-picker, .variant-picker, product-form-component, form[action*="/cart/add"]');
        if (!target) return;
        ev.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  function init(scope) {
    initReveal(scope); initTabs(scope); initCarousels(scope); initScrollTo(scope);
  }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });

  // Editor de temas: re-inicializa la sección que se recarga.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) { root.classList.remove('tf-lp-js'); init(e.target); if (!reduce && canObserve) root.classList.add('tf-lp-js'); }
  });
})();
